import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { hideLoader, showLoader } from '../../components/Loader/loaderSlice';
import { CropsService, NotificationsService } from '../../services';
import { FloatingLabelInput } from '../../components';
import { MODAL_ANIMATION_DURATION } from '../../utils';

const CreateEditPage: React.FC<PropsTypes> = ({ id, onClose, onSave }) => {
  const dispatch = useDispatch();
  const [description, setDescription] = useState('');
  const saveDisabled = useMemo(() => !description, [description]);

  const loadData = async () => {
    if (!id) {
      cleanFields();
      return;
    }

    dispatch(showLoader());
    try {
      const crop = await CropsService.findOneById(id);
      setDescription(crop.description);
    } catch (error) {
      console.error(error);
      NotificationsService.error({ message: 'Falha ao carregar Atividade para Edição' });
      onClose();
    } finally {
      dispatch(hideLoader());
    }
  };

  const onClickSave = async () => {
    const cropDescription = { description };

    try {
      if (!id) {
        await CropsService.create(cropDescription);
      } else {
        await CropsService.update(id, cropDescription);
      }
      onSave();
    } catch (error) {
      console.error(error);
      NotificationsService.error({ message: 'Falha ao Salvar Atividade' });
    } finally {
      onClickCancel();
    }
  };

  const cleanFields = () => {
    setTimeout(() => {
      setDescription('');
    }, MODAL_ANIMATION_DURATION);
  };

  const onClickCancel = () => {
    onClose();
    cleanFields();
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadData(); }, [id]);

  return (
    <div className="create-edit-page">
      <FloatingLabelInput
        label="Descrição"
        onChange={(e) => setDescription(e.currentTarget.value)}
        value={description}
      />
      <div className="field is-grouped is-grouped-right">
        <p className="control">
          <button className="button is-light" onClick={onClickCancel}>Cancelar</button>
        </p>
        <p className="control">
          <button
            className="button is-link"
            disabled={saveDisabled}
            onClick={onClickSave}
          >
            Salvar
          </button>
        </p>
      </div>
    </div>
  );
};

export default CreateEditPage;

type PropsTypes = {
  id?: string;
  onClose: () => void;
  onSave: () => void;
}
